import Cookies from 'js-cookie';
import PropTypes from 'prop-types'; // Add this import
import React, { createContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CookieStorage } from '../lib/Cookies';
import { LANG } from '../constant/lang';
export const SidebarContext = createContext()

export const SidebarProvider = ({ children }) => {
  const { i18n } = useTranslation()
  const [lang, setLang] = useState('vi')
  const [isUpdate, setIsUpdate] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingTest, setIsLoadingTest] = useState(false)

  const handleLanguageChange = (lang) => {
    Cookies.set('i18next', lang, {
      sameSite: 'None',
      secure: true,
    })
    i18n.changeLanguage(lang)
    setLang(lang)
  }

  useEffect(() => {
    const lang = CookieStorage.getLanguage() || LANG.VI
    const langContext = CookieStorage.getLanguageContext() || LANG.VI_VN
    CookieStorage.setLanguage(lang)
    CookieStorage.setLanguageContext(langContext)
  }, [lang])

  return (
    <SidebarContext.Provider
      value={{
        handleLanguageChange,
        lang,
        isUpdate,
        setIsUpdate,
        isLoading,
        setIsLoading,
        setIsLoadingTest,
        isLoadingTest
      }}
    >
      {children}
    </SidebarContext.Provider>
  )
}

SidebarProvider.propTypes = {
  children: PropTypes.node.isRequired, // Add this
}
